import { render, staticRenderFns } from "./canceledBooking.vue?vue&type=template&id=1a2462e1&"
import script from "./canceledBooking.vue?vue&type=script&lang=js&"
export * from "./canceledBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports